export const REQUESTED = 'DASHBOARD_REQUESTED';
export const FAILED = 'DASHBOARD_FAILED';
export const SUCCESSFUL = 'DASHBOARD_SUCCESSFUL';
export const SUCCESSFUL_POSTINGS = 'DASHBOARD_SUCCESSFUL_POSTINGS';
export const SUCCESSFUL_REQUESTS = 'DASHBOARD_SUCCESSFUL_REQUESTS';

export const UPDATE_FILTER = 'DASHBOARD_FILTER';
export const FILTER_REQUESTED = 'FILTER_REQUESTED';
export const FILTER_FAILED = 'FILTER_FAILED';
export const LOADING = 'DASHBOARD_LOADING';
export const INIT = 'DASHBOARD_INIT';

export const UPDATE_IGNORELIST = 'DASHBOARD_UPDATE_IGNORELIST';
export const UPDATE_WISHLIST = 'DASHBOARD_UPDATE_WISHLIST';
export const UPDATE_CONTACTEDLIST = 'DASHBOARD_UPDATE_CONTACTEDLIST';

export const UPDATE_CONTACTED = 'DASHBOARD_UPDATE_CONTACTED';

export const GET_TOTAL_COUNTS_REQUESTED = 'GET_TOTAL_COUNTS_REQUESTED';
export const GET_TOTAL_COUNTS_SUCCESSFULL = 'GET_TOTAL_COUNTS_SUCCESSFUL';
export const GET_TOTAL_COUNTS_FAILED = 'GET_TOTAL_COUNTS_FAILED';

export const REMOVE_LOADER = 'REMOVE_LOADER';

export const SYNC_DATA = 'SYNC_DATA';
export const SYNC_FAILED = 'SYNC_FAILED';

export const CONTACTED_COUNT = 'CONTACTED_COUNT';

export const ADD_STUDENT_CURRENT_DIVISION = 'ADD_STUDENT_CURRENT_DIVISION';
export const ADD_CURRENT_DIVISION_FAILED = 'ADD_CURRENT_DIVISION_FAILED';
export const ADD_CURRENT_DIVISION_REQUESTED = 'ADD_CURRENT_DIVISION_REQUESTED';

export const REQUEST_VIEWED_COUNT_FAILED = 'REQUEST_VIEWED_COUNT_FAILED';
export const REQUEST_VIEWED_COUNT_SUCCESSFUL = 'REQUEST_VIEWED_COUNT_SUCCESSFUL';
export const REQUEST_VIEWED_COUNT_REQUESTED = 'REQUEST_VIEWED_COUNT_REQUESTED';



// WEBPACK FOOTER //
// ./src/components/DashboardView/actionTypes.js